import { useEffect, useState } from "react";
import platformAPI from "../../../services/platformApi";
import s from "./platformAdmin.module.css";

const ACTION_LABELS = {
  "platform.clinic_status": "Статус клуба",
  "platform.clinic_billing": "Биллинг клуба",
};

function formatWhen(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("ru-RU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function PlatformAuditLog() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    platformAPI
      .getAuditLogs()
      .then((r) => setLogs(r.logs || []))
      .catch((e) => setErr(e.response?.data?.error || "Не удалось загрузить журнал"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={s.page}>
      <header className={s.pageHero}>
        <div>
          <div className={s.eyebrow}>BaySport · платформа</div>
          <h1 className={s.pageTitle}>Журнал действий</h1>
          <p className={s.pageLead}>
            Изменения статусов и биллинга клубов администратором платформы.
          </p>
        </div>
      </header>

      {err ? <div className={s.alertError}>{err}</div> : null}
      {loading ? <div className={s.loading}>Загрузка…</div> : null}

      {!loading && logs.length === 0 ? (
        <p className={s.muted}>Записей пока нет.</p>
      ) : (
        <div className={s.tableWrap}>
          <table className={s.dataTable}>
            <thead>
              <tr>
                <th>Когда</th>
                <th>Действие</th>
                <th>Клуб</th>
                <th>Детали</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((row) => (
                <tr key={row.id}>
                  <td>{formatWhen(row.created_at)}</td>
                  <td>{ACTION_LABELS[row.action] || row.action}</td>
                  <td>{row.entity_id?.slice(0, 8) || "—"}</td>
                  <td>
                    <code className={s.codeInline}>
                      {JSON.stringify(row.meta || {})}
                    </code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
